import {ArticleDetails} from "../../core/models/interfaces/article-details.interface";
import {AiGeneratedArticlePayload} from "../models/interfaces/ai-generated-article.interface";
import {ArticleFormSchemaType} from "../constants/article-form-schema";

export const createAiPreviewArticle = (
    payload: AiGeneratedArticlePayload,
    articleId: string | undefined,
    formData: ArticleFormSchemaType
): ArticleDetails => ({
    id: articleId ?? "ai-preview",
    title: payload.title,
    summary: payload.abstract,
    content: payload.content,
    tags: payload.tags && payload.tags.length > 0 ? payload.tags : (formData?.tags ?? []),
    recommendedSpecialists: [],
    relatedArticles: [],
    isVisible: true,
    areVersionIdentical: false,
    editedAt: new Date().toISOString(),
    isUniversal: false,
    author: {
        fullName: formData?.authorName || "",
        id: formData?.authorId || "",
        phoneNumber: "",
        specialization: ""
    },
    appId: "",
    isPostoperative: false,
    exercises: [],
    allFiles: [],
});

